import { useState, ChangeEvent, RefObject } from "react";
import ThumbnailPicker from "./ThumbnailPicker";
import "./ThumbnailPicker.scss";
import Image from "../../other/Image/Image";
import { displayNotify } from "../../../services/Notifications/NotificationServices";

interface Props {
    themeUrl: string;
    avatarUrl: string;
    triggerThemeInput: () => void;
    triggerAvatarInput: () => void;
    themeInputRef: RefObject<HTMLInputElement>;
    avatarInputRef: RefObject<HTMLInputElement>;
    handleThemeChange: (e: ChangeEvent<HTMLInputElement>) => Promise<void>;
    handleAvatarUpload: (file: File) => Promise<void>;
}

export default function ProfileImages({
    themeUrl,
    avatarUrl,
    triggerThemeInput,
    triggerAvatarInput,
    themeInputRef,
    avatarInputRef,
    handleThemeChange,
    handleAvatarUpload,
}: Props) {
    const [fileForCrop, setFileForCrop] = useState<File | null>(null);

    const onAvatarChange = (e: ChangeEvent<HTMLInputElement>) => {
        const file = e.target.files?.[0];
        if (!file) return;

        const allowed = [
            "image/png",
            "image/jpeg",
            "image/jpg",
            // "image/gif",
            "image/webp",
        ];

        if (!allowed.includes(file.type)) {
            displayNotify({
                status: "error",
                title: "Ошибка",
                description:
                    "Неподдерживаемый формат. Поддерживаются png, jpg/jpeg, gif и webp.",
            });
            e.target.value = "";
            return;
        }

        setFileForCrop(file);
        e.target.value = "";
    };

    return (
        <div className="universaleditmodal-left-images">
            <div className="universaleditmodal-left-images-theme">
                <Image
                    src={themeUrl}
                    resolution="banner"
                    className="universaleditmodal-left-images-theme-image"
                    onClick={triggerThemeInput}
                    alt="theme"
                    sizes='397px'
                />

                <input
                    type="file"
                    ref={themeInputRef}
                    onChange={handleThemeChange}
                    accept="image/*"
                    style={{ display: "none" }}
                />

                <Image
                    src="../modal/themeHover.svg"
                    resolution="banner"
                    alt=""
                    className="universaleditmodal-left-images-theme-hover"
                />
            </div>

            <div className="universaleditmodal-left-images-avatar">
                <Image
                    src={avatarUrl}
                    resolution="avatar"
                    alt="avatar"
                    sizes='86px'
                    className="universaleditmodal-left-images-avatar-image"
                    onClick={triggerAvatarInput}
                />

                <input
                    type="file"
                    ref={avatarInputRef}
                    onChange={onAvatarChange}
                    accept="image/*,video/webm"
                    style={{ display: "none" }}
                />

                <Image
                    src="../modal/avatarHover.svg"
                    resolution="avatar"
                    alt=""
                    className="universaleditmodal-left-images-avatar-hover"
                />
            </div>

            {fileForCrop && (
                <ThumbnailPicker
                    file={fileForCrop}
                    onClose={() => setFileForCrop(null)}
                    onSave={handleAvatarUpload}
                />
            )}
        </div>
    );
}
